import { FileValidatorFunction } from 'src/common/components/upload-file/upload-file.types';

export const validateFileSize =
  (MAX_SIZE_MB = 2): FileValidatorFunction =>
  (file) => {
    const fileSizeMB = file.size / 1024 ** 2;
    const valid = fileSizeMB <= MAX_SIZE_MB;
    return {
      valid,
      error: valid ? null : `[${file.name}] - File too big`,
    };
  };

export const validateFileFormat =
  (VALID_FORMATS: string[] = ['image/jpeg', 'image/gif', 'image/png']): FileValidatorFunction =>
  (file) => {
    const valid = VALID_FORMATS.includes(file.type);
    return {
      valid,
      error: valid ? null : `[${file.name}] - Invalid file format`,
    };
  };
